import AppPage from '../../mixins/app-page'

import AppTitle from '../app-title'
import AppImgBg from '../app-img-bg'
import AppBtnFilter from '../app-btn-filter'

import AppTeamsTableRow from '../app-teams-table-row'

import AppSeasonComingSoon from '../app-season-coming-soon'


export default
{
    name: 'page-standings',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppTitle,
        AppImgBg,
        AppBtnFilter,
        AppTeamsTableRow,
        AppSeasonComingSoon
    },

    data()
    {
        return {
            teams: [],
            filterVideoGame: null,
            videoGames: this.contentGlobal.videoGames,
            countdownFinished: false,
            bgChanged: false
        }
    },

    created()
    {
        this.videoGames = [this.contentPage.gameOverall].concat(this.videoGames)

        this._onFilterVideoGame(0)

        this.eventHub.$on('app-season-coming-soon:countdown-update', this._onCountdownUpdate)
    },

    destroyed()
    {
        this.eventHub.$off('app-season-coming-soon:countdown-update', this._onCountdownUpdate)
    },

    methods:
    {
        _onCountdownUpdate(countdown)
        {
            if (countdown.milliseconds <= 0)
            {
                this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
                this.countdownFinished = true
            }
            else if (!this.bgChanged)
            {
                this.bgChanged = true
                this.eventHub.$emit('bg-change', '/static/bg/bg-coming-soon.jpg')
                this.countdownFinished = false
            }
        },

        sortTeams()
        {
            const teams = JSON.parse(JSON.stringify(this.contentGlobal.teams))

            const map = team =>
            {
                team.team = teams.find(data => data.id === team.id)
                if (isNaN(team.win) || isNaN(team.defeat) || isNaN(team.draw))
                {
                    team.winPercent = '-'
                }
                else
                {
                    const totalMatches = team.win + team.defeat + team.draw
                    if (totalMatches > 0)
                    {
                        team.winPercent = Math.round(team.win * 100 / totalMatches)
                    }
                    else
                    {
                        team.winPercent = '-'
                    }
                }

                return team
            }

            this.teams = JSON.parse(JSON.stringify(this.contentPage.teams))
            .filter(team => team.videoGameID === parseInt(this.filterVideoGame.id, 10) || parseInt(this.filterVideoGame.id, 10) === 0)

            this.teams.map(map)

            this.teams.sort((a, b) =>
            {
                const rankDiff = a.rank - b.rank

                if (b.points === a.points
                    && b.if_equality !== 0
                    && a.if_equality !== 0)
                {
                    return a.if_equality - b.if_equality
                }

                if (rankDiff !== 0)
                {
                    return rankDiff
                }

                return b.points - a.points
            })

            this.teams = this.teams.filter(team => team.videoGameID === parseInt(this.filterVideoGame.id, 10))

            this.teams = this.teams.map(map)
        },

        _getVideoGameFromID(id)
        {
            return this.videoGames.find(game => +(game.id) === id)
        },

        _onFilterVideoGame(index)
        {
            this.filterVideoGame = this._getVideoGameFromID(index)

            if (index === 0)
            {
                this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
            }
            else
            {
                this.eventHub.$emit('bg-change', this.filterVideoGame.cover)
            }

            this.sortTeams()
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-standings/script.js